import { useAppSelector } from "app/hooks";
import { appFeaturesSelectors } from "features/appFeatures/store/selectors";
import { AppFeature } from "features/appFeatures/types/AppFeature";
import { RootState } from "app/store";
import { Navigate } from "react-router-dom";

export function Home() {
    const hasLiveStreamAccess = useAppSelector((state: RootState) =>
        appFeaturesSelectors.selectUserHasFeatures(state, [
            AppFeature.LiveStreaming,
        ]),
    );
    const hasPlaybackAccess = useAppSelector((state: RootState) =>
        appFeaturesSelectors.selectUserHasFeatures(state, [
            AppFeature.Playback,
        ]),
    );

    if (hasLiveStreamAccess) {
        return (
            <Navigate
                to="/livestreaming"
                replace
            />
        );
    } else if (hasPlaybackAccess) {
        return (
            <Navigate
                to="/playback"
                replace
            />
        );
    }
}
